import { HugeiconsIcon } from "@hugeicons/react";
import { Cancel01Icon } from "@hugeicons-pro/core-stroke-rounded";
import { Button, DialogClose } from "@workspace/frontend-ui";
import type { FC } from "react";

type Props = {
  label: string;
};

const SearchModalCloseButton: FC<Props> = ({ label }) => (
  <DialogClose asChild>
    <Button
      variant="outline"
      size="icon-xl"
      className="order-2 md:order-3 shadow-[0px_2px_16px_0px_rgba(0,0,0,0.12)] size-11"
      data-testid="search-overlay-close-button"
    >
      <HugeiconsIcon icon={Cancel01Icon} />
      <span className="sr-only">{label}</span>
    </Button>
  </DialogClose>
);

export default SearchModalCloseButton;
